<template>
  <li v-if="visible" :class="classes.container" class="fw-step">
    <a
      href=""
      :class="classes.wrapper"
      class="fw-step__wrapper"
      :tabindex="isDisabled ? -1 : 0"
      role="tab"
      :aria-selected="active"
      @click.prevent="select"
      @keypress.enter.space.prevent="select"
    >
      <span class="fw-step__index">{{ index + 1 }}</span>
      <slot>
        <!-- If label is a component -->
        <span v-if="isLabelComponent" class="fw-step__label">
          <component :is="stepLabel" :form$="form$"/>
        </span>

        <!-- If label is HTML -->
        <span v-else class="fw-step__label" v-html="stepLabel"></span>
      </slot>
      <span v-if="invalid && !active" class="fw-step__badge fw-step__badge--error" :aria-label="form$?.$vueform?.i18n?.locales?.[form$.$vueform.i18n.locale]?.festiware?.steps?.errorBadge || 'Error'">!</span>
    </a>
  </li>
</template>

<script>
  export default {
    name: 'FormStep',
    data() {
      return {
        merge: true,
        defaultClasses: {
          container: 'vf-step',
          wrapper: '',
          container_active: 'vf-step-active',
          container_inactive: '',
          container_invalid: 'vf-step-invalid',
          container_valid: '',
          container_disabled: 'vf-step-disabled',
          container_enabled: '',
          container_completed: 'vf-step-completed',
          container_incompleted: '',
          container_pending: 'vf-step-pending',
          $container: (classes, { active, isDisabled, completed, invalid, pending }) => ([
            classes.container,
            active ? classes.container_active : classes.container_inactive,
            isDisabled ? classes.container_disabled : classes.container_enabled,
            completed ? classes.container_completed : classes.container_incompleted,
            invalid ? classes.container_invalid : classes.container_valid,
            pending ? classes.container_pending : null,
          ]),
        }
      }
    }
  }
</script>

<!-- Styles in assets/styles/newform/_steps.scss -->
